import GovernmentSettings from './GovernmentSettings';

export default GovernmentSettings;
